/**
 * @enum WinType - Type of win
 */
export enum WinType {
    /**
     * @member cash - cash win
     */
    Cash = <any>'cash',

    /**
     * @member module - module win
     */
    Module = <any>'module',

    /**
     * @member jackpot - jackpot win
     */
    Jackpot = <any>'jackpot',

    /**
     * @member custom - custom win
     */
    Custom = <any>'custom',

    /**
     * @member freeSpins - freeSpins
     * @type {any}
     */
    freeSpins = <any>'freeSpins',

    /**
     * @member Feature - feature
     * @type {any}
     */
    Feature = <any>'feature'
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Types/WinType.ts
 **/